// extracted by mini-css-extract-plugin
export default {"aiFacial":"_6yyFRZVwDvNP3iS+ZSY6Eg==","banner":"z6lMFZRYKp2WpjGcKD+ADg=="};